import * as React from 'react'
import classNames from 'classnames'

import TextBlock from '../../00-Primitives/TextBlock'
import style from './style.scss'

type Props = {
  className?: string
  questionText: string
}

FAQAccordionDetails.defaultProps = {
  className: '',
  link: undefined,
}

function FAQAccordionDetails(props: Props) {
  const { className, questionText } = props

  return (
    <TextBlock className={classNames(style.question, className)}>
      {questionText}
    </TextBlock>
  )
}

export default FAQAccordionDetails
